<template>
  <product-component
    :product="product"
    :disabled="someProductBilled"
    allow-remove
    allow-discount
    @delete="$emit('productsModified')"
  ></product-component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import ProductComponent from '@/components/Product.vue'
import type { TabProduct } from '@/types'

defineEmits(['productsModified'])

const props = defineProps<{
  product: TabProduct
}>()

const someProductBilled = computed(() => {
  return props.product.notBilledQuantity != props.product.quantity
})
</script>
